import { render, staticRenderFns } from "./RolePermissionsEditDialog.vue?vue&type=template&id=6210cdb3&scoped=true&"
import script from "./RolePermissionsEditDialog.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6210cdb3",
  null
  
)

export default component.exports